import {
  $3l5vvh8yg0ier as $,
  orPromise1iucc2to2udt2 as orPromise,
} from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from './FlowCollector.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function onEach(_this__u8e3s4, action) {
  // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
  // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
  return new (onEach$$inlined$unsafeTransform$1())(_this__u8e3s4, action);
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class;
function sam$kotlinx_coroutines_flow_FlowCollector$0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class === VOID) {
    class $_0 {
      constructor(function_0) {
        this.j1i_1 = function_0;
      }
      *q1e(value, $completion) {
        return yield* $(this.j1i_1(value, $completion), $completion);
      }
      j5() {
        return this.j1i_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.j5(), other.j5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.j5());
      }
    }
    initMetadataForClass($_0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class = $_0;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class;
}
function onEach$o$collect$slambda($$this$unsafeFlow, $action) {
  return constructCallableReference((value, $completion) => orPromise($completion, function *($completion) {
    var tmp0 = $$this$unsafeFlow;
    var value_0 = value;
    yield* $($action(value_0, $completion), $completion);
    yield* tmp0.q1e(value_0, $completion);
    return Unit_instance;
  }), 1);
}
var onEach$$inlined$unsafeTransform$1Class;
function onEach$$inlined$unsafeTransform$1() {
  if (onEach$$inlined$unsafeTransform$1Class === VOID) {
    class $ {
      constructor($this, $action) {
        this.k1i_1 = $this;
        this.l1i_1 = $action;
      }
      *p1e(collector, $completion) {
        var tmp = onEach$o$collect$slambda(collector, this.l1i_1);
        yield* this.k1i_1.t1d(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp), $completion);
        return Unit_instance;
      }
      t1d(collector, $completion) {
        return this.p1e(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    onEach$$inlined$unsafeTransform$1Class = $;
  }
  return onEach$$inlined$unsafeTransform$1Class;
}
//region block: exports
export {
  onEach as onEach13yrgg7fxnyl6,
};
//endregion

//# sourceMappingURL=Transform.mjs.map
